import React from 'react';
import mapPin from '../assets/map-pin.png';

export default function AreaLocationIcon({ style, ...props }) {
  return <img src={mapPin} alt="" {...props} style={{ ...style, filter: 'drop-shadow(0 0 2px rgba(255,255,255,0.6)) drop-shadow(0 0 5px rgba(255,255,255,0.3)) drop-shadow(0 0 10px rgba(255,255,255,0.1))' }} />;
}
